import { Component, ViewChild } from '@angular/core';
import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbDateStruct, NgbDatepicker, NgbDatepickerModule, NgbInputDatepicker, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { PopoverModule } from 'angular-bootstrap-md';
import { BsDatepickerConfig, BsDatepickerDirective, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TimepickerConfig, TimepickerModule } from 'ngx-bootstrap/timepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';
import { sessiondaytimeslotsService } from 'app/services/session-day-time-slots';
import { AccountSession, BookingPage, getAvailableTimeSlotsPayload } from 'app/models/booking-page.model';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { TimeZone } from 'timezones-list';
import { CcPaymentsComponent } from '../cc-payment/cc-payment.component';
import { NgxLoadingModule } from "ngx-loading";
import { MatNativeDateModule } from '@angular/material/core';
import { Util } from 'app/util';
import { MatDialog } from '@angular/material/dialog';
import { EventService } from 'app/services/event.service';
import { ErrorPageComponent } from '../error-page/error-page.component';
import { AccountService } from 'app/services/account.service';
import { SnackbarService } from 'app/services/snackbar.service';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { availableSlot, NewSlotUi, SlotUI } from 'app/models/slots.model';
import { LottieComponent } from 'ngx-lottie';
import { FuseAlertComponent } from '@fuse/components/alert';
import { LollySchedulerService } from 'app/services/lolly-scheduler.service';
import { RescheduleSuccessComponent } from '../reschedule-success/reschedule-success.component';
import { BookingService } from 'app/services/bookings.service';
import { LollyBooking, RescheduleBooking } from 'app/models/bookings.model';
import { BookingPageService } from 'app/services/booking-page.service';

@Component({
  selector: 'app-session-booking',
  standalone: true,
  providers: [
    BsDatepickerConfig, TimepickerConfig, NgbDatepickerModule,
    BsDatepickerDirective, BsDatepickerModule, NgbDatepickerModule,
    PopoverModule, NgbDatepicker
  ],
  imports: [
    CommonModule, FormsModule, NgFor, NgIf,
    PopoverModule, TimepickerModule,
    ReactiveFormsModule, MatNativeDateModule, FuseAlertComponent,
    BsDatepickerModule, BsDropdownModule, BsDatepickerModule, NgxIntlTelInputModule, LottieComponent,RescheduleSuccessComponent,
    MatStepperModule, MatSelectModule, MatInputModule, MatButtonModule, MatIconModule, MatCheckboxModule, ErrorPageComponent,
    NgbDatepicker, NgbInputDatepicker, NgbPopoverModule, NgbDatepickerModule, NgxLoadingModule],
  templateUrl: './booking-reschedule.component.html',
  styleUrl: './booking-reschedule.component.scss'
})
export class BookingRescheduleComponent {
  @ViewChild(CcPaymentsComponent) ccpayments: CcPaymentsComponent;
  @ViewChild('dp', { static: false }) datePicker: NgbDatepicker;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct = { year: 2050, month: 12, day: 15 };

  session: LollyBooking = new LollyBooking();
  selectedDate: string;
  loading = false;
  availableTimeSlots: availableSlot[] = [];
  timeSlotsUI: NewSlotUi[] = [];
  selectedSlot: SlotUI = new SlotUI();
  ScheduleBookingData: RescheduleBooking = new RescheduleBooking();
  dayOfWeek: number = 0
  paymentForm: boolean = false
  slot_form: FormGroup;
  personal_details_form: FormGroup;
  // formeoForm = this._formBuilder.group({});

  model: any;
  timeZone: string = 'Asia/Karachi';
  isPaymentRequired: boolean = false
  error: string = ''
  accountData: { account_name: string }
  bookingSuccess: boolean = false
  hideBooking: boolean = false

  payment: boolean = true
  lottieConfig: Object;
  anim: any;
  bookingId:string=null
  oldSlotSelected :boolean = false;
  bookingSlotTime:string = null;
  conflict_slots = null;
  maxSlotsCount:number = 0;
  bookingPageData: BookingPage = new BookingPage();

  // Not Needed For Now
  // TIME_ZONES: TimeZone[] = timezones

  constructor(private datePipe: DatePipe,
    public sdtsService: sessiondaytimeslotsService,
    private bookingService: BookingService,
    private _accountService: AccountService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private util: Util,
    private dialog: MatDialog,
    private _eventService: EventService,
    private _snackBarService: SnackbarService,
    private _lollySchedulerService: LollySchedulerService,
    private _bookingPageService: BookingPageService,

  ) {
    this.setMinDatePicker()
    this.lottieConfig = {
      path: "../../../../assets/images/lottie/no-records-found.json",
      renderer: "svg",
      autoplay: true,
      loop: false,

    };

    this.model = {};
  }

  submitForm(data: any): void {
    console.log(data);
  }

  ngOnInit(): void {
       // Find the matching timezone in the list
       this.slot_form = this.fb.group({
        selectedSlot: [null, Validators.required],
        calenderSelectedDate: [this.getTodayDate(), Validators.required],
        // timeZoneOffSet: [this.timeZone || null, Validators.required]
      });
  
      this.personal_details_form = this.fb.group({
        clientName: [null, Validators.required],
        clientEmail: [this.getTodayDate(), Validators.required],
        notes: [],
        phone: [null, Validators.required],
      });

    this.loadSesssionData();
 
  }

  loadSesssionData() {
    this.loading = true
    this.bookingId = this.route.snapshot.paramMap.get('id');

    this._lollySchedulerService.getBookingData(this.bookingId)
      .then((res: any) => {
        if (res.status === 'ERROR') {
          this.hideBooking = true
          this.error = 'Not Found'
          this.loading = false
          return;
        }
        this.session = this._lollySchedulerService.getData(res);
        const Date_ST  = new Date(this.session.appointment_start_time)
       
        const date = this.getDate(Date_ST);
        this.slot_form.patchValue({ calenderSelectedDate: date});
        this.selectedDate = this.datePipe.transform(Date_ST, 'longDate');
        this.dayOfWeek = Date_ST.getDay();
        this.getBookingPageData();
        this.getAccountData();

      })
      .catch(error => {
        console.error("Error fetching account session data:", error);
        this.error = 'Not Found'
        this.hideBooking = true
        this.loading = false

      }).finally(() => {
        this.loading = false
      });

  }

  async onDateSelect(flag?: 'prev' | 'next'): Promise<void> {
    try {
        this.selectedSlot = new SlotUI();

        let dateToUse: Date;
        // If flag is passed, modify current selected date
        if (flag && this.selectedDate) {
            
            const current = new Date(this.selectedDate); 
            if (flag === 'prev') {
                
                current.setDate(current.getDate() - 7);
            } else if (flag === 'next') {
                current.setDate(current.getDate() + 7);
            }
            dateToUse = current;
                const year = current.getFullYear()
                const month = current.getMonth() + 1
                const todayDateStruct: NgbDateStruct = {
                    year: year,
                    month: month,
                    day: current.getDate(),
                };
                setTimeout(()=>{
                  this.datePicker?.navigateTo({year, month})
                })
            this.slot_form.patchValue({ calenderSelectedDate: todayDateStruct }); 
            this.slot_form.updateValueAndValidity()
        } else {
            // Extract day, date, month, and year
            const { day, month, year } = this.getSelectedDateValue();
            setTimeout(()=>{

              this.datePicker?.navigateTo({year, month});
            },1000)
            dateToUse = new Date(year, month - 1, day); // Month is 0-indexed
        }

        this.selectedDate = this.datePipe.transform(dateToUse, 'longDate');
        this.dayOfWeek = dateToUse.getDay();

        // Adjust dayOfWeek to 1–7 (Mon–Sun)
        if (this.dayOfWeek === 0) {
            this.dayOfWeek = 7;
        }

        // Load conflict slots and then get available slots
        this.getConflictsSlots().then((res: any) => {
            this.conflict_slots = res?.data ?? [];
            this.getAvailableSlots(this.dayOfWeek, this.selectedDate);
        });

         // Call the method to fetch available slots
          
         this.getConflictsSlots().then((res:any)=>{
          this.conflict_slots = res?.data ?? [] ;
          
          this.getAvailableSlots(
              this.dayOfWeek,
              this.selectedDate,
          );
      })

    } catch (error) {
        console.error('Error fetching available time slots:', error);
    }
}

  getAvailableSlots(dayId: number,currentDate: string) {
    
    const accountSessionId =  this.session.account_session_uuid;
    this.loading = true;
    const timeZone = this.getLocalZoneTitle();

    // Parse currentDate string (e.g., "May 20, 2025") into a Date object
    // Parse currentDate (e.g., "May 20, 2025")
    const startDate = new Date(currentDate);
    const endDate = new Date(startDate);
    if (this.bookingPageData.accountSession.calendar_view == 'WEEK') {
        endDate.setDate(startDate.getDate() + 6); // 7-day range
    }
    else
        endDate.setDate(startDate.getDate())

    // Format as "May 20, 2025"
    const formatDate = (date: Date) =>
        date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        });

    const payload :getAvailableTimeSlotsPayload  = {
        sessionUuid: accountSessionId,
        dayId:dayId,
        startDate: formatDate(startDate),
        endDate:formatDate(endDate),
        userTimeZone:timeZone,
        activityDates:this.conflict_slots
    }
  
    const url = `/available-slots`;
    this.sdtsService
        .getSlots(payload,url)
        .then((res) => {
            this.availableTimeSlots = this.sdtsService.getData(res);
            this.generateTimeSlots();
            this.loading = false;
            console.log('Successfully got Data');
        })
        .catch((err) => {
            this.loading = false;
            console.error('Error loading Data:', err);
        });
}

  generateTimeSlots(): any[] {
    try {
        this.timeSlotsUI = [];
        this.maxSlotsCount = Math.max(...this.availableTimeSlots.map(day => day.slots.length));
        // Iterate over availableSlots
        for (const Aslot of this.availableTimeSlots) {
        
           const uiSlots = []
            for (const slot of Aslot.slots) {
                
                const slotUi = new SlotUI(slot);
          
                // Push formatted time and status into timeSlotsUI
                uiSlots.push(slotUi);
                if(this.session.session_time_slot_uuid===slot.uuid && !this.oldSlotSelected ){
                  this.oldSlotSelected = true
                  this.selectedSlot = slotUi
                  this.slot_form.patchValue({selectedSlot : slotUi });
                }
            }
            const currentLength = uiSlots.length;
            for (let i = currentLength; i < this.maxSlotsCount; i++) {
                const emptyUiSlot:SlotUI = new SlotUI();
                emptyUiSlot.time = '--';
                emptyUiSlot.available = false;
                emptyUiSlot.status = '';
                emptyUiSlot.uuid = 'N/A';
                uiSlots.push(emptyUiSlot);
                
            }

            const date = new Date(Aslot.date);
            const dayName = date.toLocaleString('en-US', { weekday: 'short' }); // e.g., Sun
            const dayNum = date.getDate(); // e.g., 25

            this.timeSlotsUI.push({slots:uiSlots, date:Aslot.date, day:dayName, dateDay:dayNum});
        }

        // this.allBooked = this.areAllSlotsBooked();

        // Return the timeSlotsUI array
        return this.timeSlotsUI;
    } catch (err) {
        console.error('Error generating time slots:', err);
        // Return an empty array in case of error
        return [];
    }
}

  onNextClick(slot: SlotUI, stepper) {
    this.selectedSlot = slot
    this.goToNextStep(stepper)
  }

  onTimeSlotClick(slot: SlotUI) {
    this.slot_form.patchValue({ selectedSlot: slot });
    this.selectedSlot = slot

    this.ScheduleBookingData.session_time_slot_uuid = slot.uuid;
    // this.ScheduleBookingData.appointment_start_time = slot.UtcDate as any;
    this.ScheduleBookingData.appointment_start_time = slot.Utc_date_time as any;
  }

  /**
     * Form stepper previous
     */
  goToPreviousStep(stepper: MatStepper) {
    stepper.previous();
  }

  /**
     * Form stepper next
     */
  goToNextStep(stepper: MatStepper) {
    stepper.next();
  }

  isFirstStep(stepper: MatStepper) {
    const firstIndex = stepper.selectedIndex == 0
    return firstIndex
  }

  isLastStep(stepper: MatStepper) {
    const lastIndex = stepper.selectedIndex == 2
    return lastIndex
  }

  submitBooking() {

    // this.ScheduleBookingData.createScheduledSession.timezone = this.slot_form.value.timeZoneOffSet.tzCode
    this.ScheduleBookingData.timezone = this.getLocalZoneTitle();
    this.bookingService.reschedule(this.ScheduleBookingData,this.bookingId).then(res => {
      this.session.appointment_start_time = this.ScheduleBookingData.appointment_start_time;
      this.bookingSlotTime = this.selectedSlot.time;
      this.bookingSuccess = true;
      this.hideBooking = true;
    }).catch(error => {
      console.log(error);
    })
  }

  setMinDatePicker() {
    this.minDate = this.getTodayDate()
  }

  getTodayDate(): NgbDateStruct {
    const today = new Date();
    const todayDateStruct: NgbDateStruct = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };

    return todayDateStruct
  }

  getDate(date?: Date): NgbDateStruct {
    if (date) {
      return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      };
    }
  
    const today = new Date();
    return {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
  }

  getSelectedDateValue(): NgbDateStruct {
    return this.slot_form.get('calenderSelectedDate')?.value;
  }

  getTimeZoneValue(): TimeZone {
    return this.slot_form.get('timeZoneOffSet')?.value;
  }

  isFormsValid() {
    return this.selectedSlot.uuid
    // && (this.paymentForm || !this.isPaymentRequired
  }

  getlocalZone(): string {
    const offset = new Date().getTimezoneOffset();
    const hours = Math.floor(Math.abs(offset) / 60);
    const minutes = Math.abs(offset) % 60;

    // Determine the sign: "-" if the offset is positive (behind UTC), "+" if negative (ahead of UTC)
    const sign = offset > 0 ? '-' : '+';

    // Format hours and minutes with leading zeros
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${sign}${formattedHours}:${formattedMinutes}`;
  }

  getAccountData() {
    this._accountService.getAccount(this.session.account_uuid).then(res => {
      this.accountData = this._accountService.getData(res)
      this._eventService.onAccountLoad.emit(this.accountData.account_name)

    }).catch(error => {
      console.log(error)
    })
  }

  onInputChange(event) {
    console.log(event)
  }

  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required])
  });

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }

  isInvalidPhoneNumber(): boolean {
    return this.personal_details_form.get('phone').hasError('validatePhoneNumber')
  }

  isEmptyPhoneNumber(): boolean {
    return this.personal_details_form.get('phone').hasError('required')
  }

  // // Time Zone Dropdown 
  // onTimeZoneChange(change: MatSelectChange) {
  //   const updatedValue: TimeZone = change.value
  //   const timeZone: number = Number(updatedValue.utc)
  //   if (this.selectedDate) {
  //     this.getAvailableSlots(this.session.account_session_uuid, this.dayOfWeek, this.selectedDate, timeZone);
  //   }
  // }

  handleAnimation(anim: any) {
    this.anim = anim;
  }

  getLocalZoneTitle(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

getConflictsSlots(){
  return new Promise((resolve,reject)=>{
      const userId = Number(this.session?.conflict_ref_id) ?? null;
      const dateString = this.selectedDate
      const date = new Date(dateString);
      
      // Format it in local time
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
      const day = String(date.getDate()).padStart(2, '0');
      
      const formattedDate = `${year}-${month}-${day}`;
      if(userId){
          this._lollySchedulerService.getConflictSlots({userId:userId,date:formattedDate}).then(res=>{
              resolve(res)
          }).catch(error=>{
              resolve(null)
          })
      }
      else{
          resolve(null)
      }
       
  })
}

getBookingPageData(){
  
  this._bookingPageService.getById(this.session.account_session_uuid).then((res:any)=>{
   this.bookingPageData = this._bookingPageService.getData(res);
   this.onDateSelect();
  }).catch(error => {
    console.error("Error fetching booking data:", error);
    // this.hideBooking = true
    // this.error = 'Not Found';
    this.onDateSelect();
  })
}

}
